import Vue from "vue"
import Message from "./message"
import { isVnode } from "../../utils/context"

const MessageConstructor = Vue.extend(Message)
const PRE_DEFINED_TYPES = ["success", "warning", "info", "error", "loading"]

const message = function(options) {
  const instance = new MessageConstructor({
    propsData: options,
  })

  if (isVnode(options.message)) {
    instance.$slots.default = [options.message]
    instance.message = ""
  }

  instance.$mount()

  let container = document.body.querySelector(".mm-messages-container")

  if (!container) {
    container = document.createElement("div")
    container.className = "mm-messages-container"
    document.body.appendChild(container)
  }

  container.appendChild(instance.$el)
  instance.visible = true

  return instance
}

PRE_DEFINED_TYPES.forEach(type => {
  message[type] = options => {
    const optionsType = typeof options
    if (!(optionsType === "string" || optionsType === "object")) {
      return
    }

    if (optionsType === "string") {
      options = { message: options }
    }

    if (type === "loading") {
      options.duration = options.duration || 0
    }

    options.type = type
    return message(options)
  }
})

export default message
